import React from 'react';
import { Heading as ChakraHeading, HeadingProps } from '@chakra-ui/react';

const getDefaultHeadingSize = (headingAsProp: string | undefined): string => {
  const heading = headingAsProp || 'h2';
  switch (heading) {
    case 'h1':
      return 'xl';
    case 'h2':
      return 'lg';
    case 'h3':
      return 'sm';
    case 'h4':
      return 'sm';
    case 'h5':
    case 'h6':
    default:
      return 'xs';
  }
};

const Heading = (props: HeadingProps) => {
  const { as: asProp } = props;
  const defaultSize = getDefaultHeadingSize(
    typeof asProp === 'string' ? asProp : undefined,
  );
  return <ChakraHeading size={defaultSize} {...props} />;
};

export default Heading;
